import React from "react"
import Modal from "react-modal"

import Button from "components/common/Button"
import { Headline3 } from "components/common/styles"
import { modalStyles } from "components/modals/closeComposerModal"

import ChannelAvatarBadge from "./ChannelAvatarBadge"
import * as styles from "../styles"
import { CreationChannel } from "../types"

export type ChannelListEntry = {
  key: string
  channel: CreationChannel | null
  label: string
  hint?: string
}

type ChannelListModalProps<T extends ChannelListEntry> = {
  modalName: string
  isOpen: boolean
  title: string
  description?: string
  entries: T[]
  onSelect: (entry: T) => void
  onClose: () => void
}

const ChannelListModal = <T extends ChannelListEntry>({
  modalName,
  isOpen,
  title,
  description,
  entries,
  onSelect,
  onClose,
}: ChannelListModalProps<T>) => {
  const reactModalStyles = modalStyles(360)

  return (
    <Modal
      // @ts-ignore
      name={modalName}
      ariaHideApp={false}
      isOpen={isOpen}
      // @ts-ignore
      style={reactModalStyles}
      onRequestClose={onClose}
    >
      <styles.ModalInfoWrapper>
        <styles.ModalContentWrapper>
          <Headline3>{title}</Headline3>
          {description && <styles.ModalInfoPara>{description}</styles.ModalInfoPara>}
        </styles.ModalContentWrapper>
        <styles.ChannelListModalList>
          {entries.map((entry) => (
            <styles.ChannelMenuItem
              key={entry.key}
              type="button"
              onClick={() => onSelect(entry)}
              data-testid={`channel-list-option-${entry.key}`}
            >
              <ChannelAvatarBadge channel={entry.channel} />
              <styles.ChannelListModalLabel>
                <span>{entry.label}</span>
                {entry.hint && <styles.ChannelListModalHint>{entry.hint}</styles.ChannelListModalHint>}
              </styles.ChannelListModalLabel>
            </styles.ChannelMenuItem>
          ))}
        </styles.ChannelListModalList>
        <styles.ModalButtonGroup>
          {/* @ts-ignore */}
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
        </styles.ModalButtonGroup>
      </styles.ModalInfoWrapper>
    </Modal>
  )
}

export default ChannelListModal
